module.exports = __webpack_public_path__ + "img/user.39e7e38d.png";